export const gitCommit = 'b5be4556'
